<ng-template #itemTemplate let-item="item" let-index="index">
  <span class="index">{{ index }})</span> {{ item.text }}
  <span class="remove" (click)="removeById(item.id)">[remove]</span>
</ng-template>

<app-demo
  [datasource]="datasource"
  [context]="demoContext"
  [sources]="sources"
  [itemTemplate]="itemTemplate"
>
  <div actions>
    <input
      [(ngModel)]="inputValue"
      (change)="onInputChanged($any($event.target))"
      size="3"
    />
    <button (click)="removeByIndex(inputValue)">Remove by index</button>
  </div>
  <div description>
    <p>
      The <em>Adapter.remove</em> method allows us to remove items from current
      buffer or/and virtually. The argument of this method is an object of the
      following type:
    </p>
    <pre>{{ argumentsDescription }}</pre>
    <p>
      The <em>predicate</em> option is a function applying to each item in the
      buffer. If the return value is true, the item will be removed. The
      argument of the predicate is of <em>ItemAdapter</em> type, and in this
      demo we have the following version of <em>predicate</em> for removing by
      id:
    </p>
    <pre>{{ predicateDescription }}</pre>
    <p>
      Indexes are adjusted each time a delete is performed via Adapter. For
      example, it's impossible to remove item with id = 5 twice, because there
      is only one item with id = 5. But we may remove item with index = 5 as
      many times as many indexes we have after this one.
    </p>
    <p>
      Instead of <em>predicate</em> running over buffered items, it is possible
      to remove items by <em>indexes</em>. This method works with both buffered
      and virtual items. For example, we have [1..10] buffered items (they are
      rendered) and [11..100] virtual items (emulated via forward padding
      element which size corresponds to 90 virtual items), and we want to remove
      the last item via <em>Adapter.remove(&#123; indexes: [100] &#125;)</em>,
      the result will be as follows:
    </p>
    <ul>
      <li>buffer is not affected</li>
      <li>the visible part of the viewport remains the same</li>
      <li>
        size of the forward padding is reduced by size of the 100th item, so the
        scrollable area becomes slightly smaller
      </li>
    </ul>
    <p>
      By default, indexes are decreased, that is, the indexes following the
      deleted one(s) are decremented. The <em>increase</em> option allows us to
      change the default indexes adjustment strategy. By setting
      <em>increase</em> to <em>true</em>, we tell the Scroller that we want to
      increase indexes of the items before the removed one(s).
    </p>
    <p>
      The very important point is that we need to synchronize the Datasource
      with the changes we are making over the Scroller's buffer via
      <em>Adapter.remove</em>. Generally, this is the App component
      responsibility, and in this demo it is done by the
      <em>removeFromDatasource</em> method. It removes 1 item from the initial
      dataset, and decrements the value of the right border.
    </p>
  </div>
</app-demo>
